import type { App } from 'vue';
import { Message } from '@arco-design/web-vue';
import type { MessageConfig } from '@arco-design/web-vue/es/message/interface';

/** 同一位置只保留一条错误提示；新错误会替换文案并重置展示时间 */
const SINGLETON_ERROR_ID = '__admin_singleton_error';

type MessageErrorFn = (
  config: string | MessageConfig,
  appContext?: import('vue').AppContext,
) => ReturnType<typeof Message.error>;

function wrapMessageError(orig: MessageErrorFn): MessageErrorFn {
  return (config, appContext) => {
    if (typeof config === 'string') {
      return orig({ content: config, id: SINGLETON_ERROR_ID, duration: 5000 }, appContext);
    }
    return orig({ ...config, id: SINGLETON_ERROR_ID }, appContext);
  };
}

/**
 * 全局限制错误 Message 同时最多一条（Arco 同 id 会更新而非叠加）。
 * 需在使用 ArcoVue 之后调用，以便一并改写 $message.error。
 */
export function installSingletonErrorMessage(app: App) {
  const origModule = Message.error.bind(Message) as MessageErrorFn;
  (Message as { error: MessageErrorFn }).error = wrapMessageError(origModule);

  const $message = app.config.globalProperties.$message as typeof Message | undefined;
  if ($message?.error) {
    const origGlobal = $message.error.bind($message) as MessageErrorFn;
    ($message as { error: MessageErrorFn }).error = wrapMessageError(origGlobal);
  }
}
